module.exports = __webpack_public_path__ + "img/di1.54dbef41.jpg";